"use client";
import useFilters from "@/app/lib/features/filters/filters.hook";
import SpecialFiltersSwiper from "../filters/SpecialFiltersSwiper";
import ProductFilterSystem from "../filters/ProductFilterSystem";
import { Button } from "@/app/components/shadcn/button";
import { SlidersHorizontal } from "lucide-react";

interface StoreAllProductsHeaderProps {
  title: string;
  totalProducts?: number;
  onOpenFilter?: () => void;
}

const StoreAllProductsHeader = ({
  title,
  totalProducts,
  onOpenFilter,
}: StoreAllProductsHeaderProps) => {
  const { specialFilters, selected, toggleSpecial, generalStatus } =
    useFilters();

  return (
    <div className="space-y-3">
      <div className="flex items-center gap-2">
        <p className="font-medium text-lg">{title}</p>
        {totalProducts !== undefined && (
          <p className="text-sm text-muted-foreground">
            {totalProducts.toLocaleString("tr-TR")}+ Ürün
          </p>
        )}
      </div>

      <div className="flex items-center gap-2">
        {onOpenFilter && (
          <Button
            variant="outline"
            size="sm"
            className="lg:hidden shrink-0 gap-1.5 h-8"
            onClick={onOpenFilter}
          >
            <SlidersHorizontal size={14} />
            Filtrele
          </Button>
        )}
        {generalStatus === "success" && specialFilters.length > 0 && (
          <div className="flex-1 min-w-0">
            <SpecialFiltersSwiper
              specialFilters={specialFilters}
              selected={selected}
              toggleSpecial={toggleSpecial}
            />
          </div>
        )}
      </div>

      <ProductFilterSystem />
    </div>
  );
};

export default StoreAllProductsHeader;
